export const actionTypes = Object.freeze({
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGOUT: 'LOGOUT',
    LATEST_SCROLL: 'LATEST_SCROLL'
})
